import Base from "../Base";
import {colorById} from "../../helpers/ColorHelper";
import { getImageUrl } from "@common/ImageUrlHelper";

export default class Profile extends Base{
    id;
    lastName;
    firstName;
    photoFileId;
    userId;
    position;
    company;

    integers = ['userId'];

    constructor(data) {
        super();
        this.setUp(this, data);
    }

    /**
     *
     * @param session {Session}
     * @returns {string}
     */
    photoUrl(session) {
        return getImageUrl(session.backend, this.photoFileId, 88);
    }

    color() {
        return colorById(this.id);
    }

    fullName() {
        return [this.firstName, this.lastName].filter(item => item).join(' ');
    }

    initials() {
        const firstName = this.firstName ? (this.firstName[0] || '') : '',
              lastName = this.lastName ? (this.lastName[0] || '') : '';
        return [firstName, lastName].filter(item => item).join('');
    }

    workInfo() {
        return [this.company, this.position].filter(item => item).join(', ');
    }
}